import React from 'react';
import './About.css'; // We'll create this CSS file

// Static team members data - using your actual team member images
const staticTeamMembers = [
  {
    id: 1,
    name: 'Miss Asnaku W/tinsae',
    role: 'Caregiver',
    photo: { url: '/team memebers/miss Asnaku wtinsae, caregiver.jpg' }
  },
  {
    id: 2,
    name: 'Miss Aster Teshom',
    role: 'Caregiver',
    photo: { url: '/team memebers/miss Aster teshom, caregiver.jpg' }
  },
  {
    id: 3,
    name: 'Miss Atalel Getachew',
    role: 'Admin',
    photo: { url: '/team memebers/miss Atalel Getachew, admin.jpg' }
  },
  {
    id: 4,
    name: 'Miss Eyerusalem Estifanos',
    role: 'Main Teacher',
    photo: { url: '/team memebers/miss Eyerusalem Estifanos, main teacher.jpg' }
  },
  {
    id: 5,
    name: 'Miss Selamawit Tekalign',
    role: 'Main Teacher',
    photo: { url: '/team memebers/miss Selamawit tekalign, main teacher.jpg' }
  },
  {
    id: 6,
    name: 'Miss Kidist Zerihun',
    role: 'Main Teacher',
    photo: { url: '/team memebers/miss Kidist Zerihun, main teacher.jpg' }
  }
];

function About() {
  const teamMembers = staticTeamMembers;

  return (
    <div id="about" className="about-container">
      <h1>About Bubbles Early Years School</h1>
      <p className="intro-text">
        At Bubbles Early Years School, we believe every child is a unique individual with boundless potential.
        Our mission is to provide a stimulating, safe, and nurturing environment where children can explore,
        learn, and grow with joy and confidence.
      </p>

      <div className="mission-vision-section">
        <div className="card">
          <h2>ðŸŒŸ Our Promise</h2>
          <ul className="promise-list">
            <li>âœ¨ A warm, safe, and nurturing environment</li>
            <li>âœ¨ Experienced and caring teachers</li>
            <li>âœ¨ Small class sizes for individual attention</li>
            <li>âœ¨ A happy school experience that children look forward to every day</li>
          </ul>
        </div>
        <div className="card">
          <h2>ðŸŒŸ Our Mission</h2>
          <ul className="promise-list">
            <li>âœ¨ To inspire a lifelong love for learning through play-based curriculum</li>
            <li>âœ¨ Foster creativity</li>
            <li>âœ¨ Develop essential social and emotional skills in children aged 1-6</li>
          </ul>
        </div>
      </div>

      <div className="team-section">
        <h2>Meet Our Wonderful Team</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-member">
              {member.photo ? (
                <img
                  src={member.photo.url}
                  alt={member.name}
                  className="member-photo"
                  style={{ width: '150px', height: '150px', objectFit: 'cover', borderRadius: '50%' }}
                />
              ) : (
                <div className="member-photo"></div>
              )}
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="values-section">
        <h2>Our Core Values</h2>
        <ul>
          <li><span>Creativity:</span> Encouraging imaginative play and innovative thinking</li>
          <li><span>Respect:</span> Fostering kindness, empathy, and mutual understanding</li>
          <li><span>Excellence:</span> Striving for high standards in early childhood education</li>
          <li><span>Community:</span> Building strong partnerships with families</li>
          <li><span>Joy:</span> Ensuring learning is a fun and delightful experience</li>
        </ul>
        <div className="registration-callout">
          <div className="cta-inline">
            <span className="cta-arrow">âž¡ï¸</span>
            <span className="cta-text">
              <strong>Limited spots available!</strong> Register today and let your child's learning journey begin with joy.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;